import React from 'react';
import classes from './LabelItem.module.css';
import cn from 'classnames';
import { Heading } from '../Heading';
import { Paragraph } from '../Paragraph';
import { Label } from '../../api/queries';

type LabelItemProps = {
  setSelectedLabels: React.Dispatch<React.SetStateAction<Array<Label>>>;
  label: Label;
  activeLabel: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export const LabelItem = ({
  setSelectedLabels,
  label,
  activeLabel,
  ...rest
}: LabelItemProps) => {
  const { className: givenClassName, ...buttonProps } = rest;
  const combinedLabelItemClassNames = cn(
    classes.labelItem,
    { [classes.labelItemActive]: activeLabel },
    givenClassName,
  );

  return (
    <button
      onClick={() => {
        setSelectedLabels((prev) => {
          return activeLabel
            ? prev.filter((prevItem) => prevItem.id !== label.id)
            : [...prev, label];
        });
      }}
      aria-selected={activeLabel}
      aria-pressed={activeLabel}
      name={label.name}
      className={combinedLabelItemClassNames}
      {...buttonProps}
    >
      <div className={classes.checkMark}>
        <input
          type="checkbox"
          readOnly
          aria-hidden="true"
          checked={activeLabel}
          tabIndex={-1}
        />
      </div>
      <div className={classes.dot}>
        <div
          className={classes.coloredDot}
          style={{
            backgroundColor: label.color,
          }}
        />
      </div>

      <div className={classes.text}>
        <div className={classes.titleAndColor}></div>
        <Heading as="h5" className={classes.title}>
          {label.name}
        </Heading>

        {label.description && (
          <Paragraph size="md">{label.description}</Paragraph>
        )}
      </div>
    </button>
  );
};
